import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flying_span = _resolveComponent("flying-span")!

  return (_openBlock(), _createBlock(_component_flying_span, {
    block: "",
    class: "text-white font-500 text-30px <lg:leading-28px <lg:text-18px <sm:text-14px <sm:leading-18px leading-38px mt-119px pr-10px <lg:mt-60px <sm:mt-0"
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createTextVNode(" Помогаем "),
      _createElementVNode("span", { class: "text-black relative z-1" }, [
        _createElementVNode("span", null, "заработать"),
        _createElementVNode("div", { class: "absolute top-0 left-0 -z-1 h-full w-full transform-gpu scale-102 -rotate-1 bg-hex-FFD74A" })
      ], -1),
      _createTextVNode(" на продаже банковских продуктов не выходя из дома, и создаем "),
      _createElementVNode("span", { class: "text-black relative z-1 whitespace-nowrap" }, [
        _createElementVNode("span", null, "лучший сервис в России"),
        _createElementVNode("div", { class: "absolute top-0 left-0 -z-1 h-full w-full transform-gpu scale-102 -rotate-1 bg-hex-FFD74A" })
      ], -1)
    ])),
    _: 1
  }))
}